import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { showToast } from '../utils/toast';
import { LanguageToggle } from './LanguageToggle';
import './Navbar.css';

function Navbar() {
  const { user, logout } = useAuth();
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const formatUserName = (username) => {
    if (!username) return t('nav.fitnessCoach');

    const parts = username.trim().split(/[\s._-]+/);

    if (parts.length === 1) {
      return username;
    }

    const firstName = parts[0];
    const lastName = parts[parts.length - 1];
    const lastInitial = lastName.length > 0 ? lastName[0].toUpperCase() : '';

    return `${firstName} ${lastInitial}.`;
  };

  const handleLogout = () => {
    logout();
    showToast.info(t('nav.logoutSuccess'));
    navigate('/login');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <h2>{user ? formatUserName(user.username) : t('nav.fitnessCoach')}</h2>
        </div>

        <div className="nav-right">
          <div className="nav-lang-desktop" aria-hidden={false}>
            <LanguageToggle />
          </div>

          <button
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <div className="nav-lang-mobile">
              <LanguageToggle />
            </div>
            <Link to="/" className="nav-link" onClick={closeMenu}>{t('nav.home')}</Link>
            {user && user.role !== 'super_admin' && (
              <>
                <Link to="/hrana" className="nav-link" onClick={closeMenu}>{t('nav.meals')}</Link>
                <Link to="/trening" className="nav-link" onClick={closeMenu}>{t('nav.workouts')}</Link>
                <Link to="/sabloni" className="nav-link" onClick={closeMenu}>{t('nav.templates')}</Link>
              </>
            )}
            {user && user.role !== 'super_admin' && (
              <Link to="/izvestaji" className="nav-link" onClick={closeMenu}>{t('nav.reports')}</Link>
            )}
            <Link to="/profile" className="nav-link" onClick={closeMenu}>{t('nav.profile')}</Link>
            {user && (user.role === 'admin' || user.role === 'super_admin' || user.role === 'coach') && (
              <Link to="/admin" className="nav-link" onClick={closeMenu}>{t('nav.admin')}</Link>
            )}
            <button onClick={handleLogout} className="nav-button">{t('nav.logout')}</button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
